var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductionCompanyForm',{attrs:{"loading":_vm.loading,"items":_vm.items,"title":_vm.title,"type":_vm.type},on:{"getProductionDetail":_vm.getProductionDetail,"update:loading":function($event){_vm.loading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }